import { urlBuilder } from '../Shared/urlBuilder';

export const externalAccountCreationPath = (accountId: number, action?: 'deposit' | 'withdrawal') => {
  const exitTo = urlBuilder.getAppChecking.absolute();
  let returnTo = exitTo;
  if (action === 'deposit') {
    returnTo = `${urlBuilder.getAppCheckingAccountDepositSetup.absolute({ accountId })}/amount`;
  }
  if (action === 'withdrawal') {
    returnTo = `${urlBuilder.getCheckingWithdrawalSetup.absolute({ accountId })}/amount`;
  }
  return urlBuilder.appCheckingExternalAccountSetup.absolute({ return_to: returnTo, exit_to: exitTo });
};
